module.exports = __webpack_public_path__ + "static/media/pilot05.3aa751c2.jpg";